import { useState } from 'react';
import { Info } from 'lucide-react';

interface FilterInfoButtonProps {
    id: string;
    text: string;
}

const FilterInfoButton = ({ id, text }: FilterInfoButtonProps) => {
    const [open, setOpen] = useState(false);

    return (
        <span style={{ position: 'relative', display: 'inline-flex', alignItems: 'center' }}>
            <span
                className="ms-1 text-muted"
                style={{ cursor: 'pointer', display: 'inline-flex', verticalAlign: 'middle' }}
                role="button"
                aria-label="Meer informatie"
                onClick={() => setOpen(v => !v)}
            >
                <Info size={14} />
            </span>
            {open && (
                <>
                    <div
                        style={{ position: 'fixed', inset: 0, zIndex: 999 }}
                        onClick={() => setOpen(false)}
                    />
                    <div
                        id={id}
                        style={{
                            position: 'absolute',
                            top: '20px',
                            left: '0',
                            zIndex: 1000,
                            background: 'white',
                            border: '1px solid rgba(0,0,0,.2)',
                            borderRadius: '6px',
                            padding: '8px 12px',
                            fontSize: '0.83rem',
                            lineHeight: '1.5',
                            width: '320px',
                            boxShadow: '0 2px 8px rgba(0,0,0,.15)',
                        }}
                    >
                        {text}
                    </div>
                </>
            )}
        </span>
    );
};

export default FilterInfoButton;
